import React, {PropTypes} from 'react';

const IncludePastTournamentsCheckbox = ({
  includePastTournaments,
  onIncludePastTournamentChange
}) => (
  <div className="custom-checkbox-container"
    style={{margin: '0 15px'}}>
    <input type="checkbox"
      id="includePastTournaments"
      checked={includePastTournaments}
      onChange={event => onIncludePastTournamentChange(event.target.checked)}/>
    <label htmlFor="includePastTournaments">{'Include Past Tournaments'}</label>
  </div>
);

IncludePastTournamentsCheckbox.propTypes = {
  includePastTournaments: PropTypes.bool,
  onIncludePastTournamentChange: PropTypes.func
};

IncludePastTournamentsCheckbox.defaultProps = {
  includePastTournaments: false
};

export default IncludePastTournamentsCheckbox;



// WEBPACK FOOTER //
// ./src/features/admin/home/IncludePastTournamentsCheckbox.jsx